import type { KgInsightThemeType } from '@api';
import { useThemeCompanyCount } from '@terminal/react-query-hooks/themes/useThemeCompanyCount';
import { useFlags } from '@terminal/stores/use-flags/useFlags';
import { useTranslation } from 'react-i18next';

export interface ThemeCompanyCountProps {
  themeId: string;
  themeType?: KgInsightThemeType;
}

export const ThemeCompanyCount = ({
  themeId,
  themeType,
}: ThemeCompanyCountProps) => {
  const { t } = useTranslation('widget');
  const isNewThemeSearchEnabled = useFlags(state =>
    state.getFeatureFlagState('KG-786-Macro_Financial_Theme')
  );
  const shouldShowCompanyCount =
    !isNewThemeSearchEnabled || themeType === 'industry';
  const companyCount = useThemeCompanyCount(
    shouldShowCompanyCount ? themeId : ''
  );

  if (!shouldShowCompanyCount || companyCount === undefined) {
    return null;
  }

  return (
    <>
      {' · '}
      {t('widget:themeOverview.companiesCounter', { count: companyCount })}
    </>
  );
};
